import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Typography, Paper } from '@mui/material';
import { z } from 'zod';

// Type-safe route parameters validation
const projectParamsSchema = z.object({
  projectId: z
    .string()
    .transform(val => parseInt(val, 10))
    .pipe(z.number().positive()),
});

export const Route = createFileRoute('/projects/$projectId')({
  component: ProjectLayoutComponent,
  params: {
    parse: params => projectParamsSchema.parse(params),
    stringify: ({ projectId }) => ({ projectId: String(projectId) }),
  },
  validateSearch: z.object({}),
  errorComponent: ({ error }) => (
    <Paper sx={{ p: 3 }}>
      <Typography variant='h6' color='error'>
        Error loading project
      </Typography>
      <Typography variant='body2' color='text.secondary'>
        {error.message}
      </Typography>
    </Paper>
  ),
  pendingComponent: () => (
    <Paper sx={{ p: 3 }}>
      <Typography variant='body1'>Loading project...</Typography>
    </Paper>
  ),
});

function ProjectLayoutComponent() {
  return <Outlet />;
}
